<template>
  <div class="stationDetailPage">
      <div class="detail-top">
        <div class="station-name">
          {{ equmentdata.siteName }}
        </div>
        <div class="station-message">
          <span>负责人：{{ equmentdata.manager }}</span>
          <span class="station-phone">联系方式：{{ equmentdata.telephone }}</span>
          <span>信号强度：{{ equmentdata.signalStrength }}</span>
        </div>
        <div class="statin-btn">
          <div class="btn-item" @click="showlist()">
            隐患详情
          </div>
          <div class="btn-item" @click="todatadetail()">
            数据详情
          </div>
        </div>
      </div>
    <div class="risk-analyse" v-show="showrisk">
      <div class="analyes-title">
        24小时隐患分析
      </div>
      <div class="gray-line">

      </div>
      <div class="analyes-cav">
        <div class="cav-title">
          <div class="item-group">
            <span class="item-btn " :class="itemType==item.riskName?'active-btn':''" @click="changeitem(item.riskName)" v-for="item in riskAll">
              {{ item.riskName }}
              <div class="blue-blank">

              </div>
            </span>

            <div class="gray-line">

            </div>
          </div>
          <div class="title-detail">
            {{alertMessage}}
          </div>
          <div class="cav-chart" id="analyesCav">

          </div>
        </div>
      </div>
    </div>
    <div class="data-analyse">
      <div class="analyes-title">
        数据分析
      </div>
      <div class="gray-line">

      </div>
      <div class="analyes-cav">
        <div class="item-group">
            <span class="item-btn " :class="issave=='aqjc'?'active-btn':''" @click="changesave('aqjc')">
              安全监测
              <div class="blue-blank">

              </div>
            </span>
          <span class="item-btn " :class="issave=='nyjc'?'active-btn':''" @click="changesave('nyjc')">
              能源监测
              <div class="blue-blank">

              </div>
            </span>
          <div class="gray-line">

          </div>
        </div>

        <div class="ny-all" v-show="issave=='nyjc'">
          <powerdata/>
        </div>
        <div class="save-all" v-show="issave=='aqjc'">
          <div class="power-data">
            监测点安全数据
          </div>
          <div class="data-card">
            <div class="btn-item" v-loading="isload" @click="getnewdata()">
              获取实时数据
            </div>
            <div class="save-item">
              <div class="blue-blank">

              </div>
              <div class="save-content">
                <div >
                  漏电流(mA)：<span :class="'font' + elelast.lev" style="margin-right: 20px;">{{ elelast.value }}</span>
                  <span v-show="isthree!='2'">箱温(℃)：<span  :class="'font' + boxtem.lev">{{ boxtem.value }}</span></span>
                </div>
                <div class="item-tips">
                  提示：<span class="red-font ">红色</span>代表危险、<span class="green-font">绿色</span>代表安全
                </div>
              </div>
            </div>
            <div class="save-item">
              <div class="blue-blank">

              </div>
              <div class="save-content">
                <div >
                  电气火灾风险指数：<span :class="'font' + dqhzparm.lev"  style="margin-right: 20px;">{{ dqhzparm.value }}</span>
                  <span v-if="jylhparm.value">绝缘老化风险指数:</span><span :class="'font' + jylhparm.lev" >{{ jylhparm.value }}</span>
                </div>
                <div class="item-tips">
                  提示：<span class="red-font">红色</span>代表重大风险、<span class="org-font">橙色</span>代表较大风险、<span class="yel-font">黄色</span>代表一般风险、
                  <span class="blue-font">蓝色</span>代表一般风险、<span class="green-font">绿色</span>代表无风险
                </div>
              </div>
            </div>

          </div>
          <div class="data-table" v-show="isthree!=null">
            <div class="singletable" v-if="isthree=='2'">
              <div class="table-top">
                <span>剩余电流（mA）</span>
                <span>剩余基波电流（mA）</span>
                <span>剩余谐波电流（mA）</span>
                <span>电压（V）</span>
                <span>负荷电流（A）</span>
                <span>基波电流（A）</span>
                <span>谐波电流（A）</span>

                <span>功率因数</span>
                <span>有功功率(W)</span>
                <span>有功电度(kwh)</span>
                <!-- <span>温度(℃)</span> -->
                <span>零线温度(℃)</span>
                <span>火线温度(℃)</span>

              </div>
              <div class="table-bom">

                <span  v-for="item in singlesavedata[0].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>
                <span  v-for="item in singlesavedata[1].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>
                <span  v-for="item in singlesavedata[2].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>
                <span  v-for="item in singlesavedata[3].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>
                <span  v-for="item in singlesavedata[5].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>
                <span  v-for="item in singlesavedata[4].paramSafeDataList" :class="'font' + item.checkSafe" >
                   <span style="width: 60px;">
                    {{ (item.paramValue * electricMul).toFixed(4)}}
                   </span>
                  <span style="font-size: 10px;">
                      ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(4)}})
                  </span>

                </span>
                <!--<span  v-for="item in singlesavedata[6].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>-->
                <span  v-for="item in singlesavedata[7].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>
                <span  v-for="item in singlesavedata[8].paramSafeDataList" :class="'font' + item.checkSafe" >{{item.paramValue=='-45.0'?'-':item.paramValue}}</span>
              </div>
            </div>
            <div class="alltable" v-else-if="isthree=='1'">
              <div v-if="isb">
                <div class="table-top">
                  <span></span>
                  <span>电压（V）</span>
                  <span>电流（A）</span>
<!--                  <span>谐波电流（A）</span>-->
                  <span>有功电度(kwh)</span>
                  <span>有功功率（W）</span>
                  <span>功率因数</span>
                  <span>温度(°C)</span>
                </div>
                <div class="table-bom">
                  <span>A相</span>
                  <span v-for="(item , index) in threesavedata[0].paramSafeDataList"  :class="'font' + item.checkSafe" v-show="index!=2">
                  <span v-if="index!=3 ">
                     {{item.paramValue=='-45.0'?'-':item.paramValue}}
                  </span>
                 <span v-else style="width: 100%;background-color: none;">
                          <span style="width: 60px;display: inline-block;background-color: none;">
                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}
                   </span>
                  <span style="font-size: 10px;">
                      ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})
                  </span>
                 </span>
                </span>

                </div>
                <div class="table-bom">
                  <span>B相</span>
                  <span v-for="(item , index) in threesavedata[1].paramSafeDataList" :class="'font' + item.checkSafe" v-show="index!=2">
                     <span v-if="index!=3 ">
                     {{item.paramValue=='-45.0'?'-':item.paramValue}}
                  </span>
                 <span v-else style="width: 100%;background-color: none;">
                          <span style="width: 60px;display: inline-block;background-color: none;">
                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}
                   </span>
                  <span style="font-size: 10px;">
                      ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})
                  </span>
                 </span>
                </span>
                </div>
                <div class="table-bom">
                  <span>C相</span>
                  <span v-for="(item , index) in threesavedata[2].paramSafeDataList" :class="'font' + item.checkSafe" v-show="index!=2">
                     <span v-if="index!=3">
                     {{item.paramValue=='-45.0'?'-':item.paramValue}}
                  </span>
                 <span v-else style="width: 100%;background-color: none;">
                          <span style="width: 60px;display: inline-block;background-color: none;">
                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}
                   </span>
                  <span style="font-size: 10px;">
                      ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})
                  </span>
                 </span>
                </span>
                </div>
              </div>
              <div v-else>
                <div class="table-top">
                  <span></span>
                  <span>电压（V）</span>
                  <span>电流（A）</span>
                  <span>谐波电流（A）</span>
                  <span>有功电度(kwh)</span>
                  <span>有功功率（W）</span>
                  <span>功率因数</span>
                  <span>温度(°C)</span>
                </div>
                <div class="table-bom">
                  <span>A相</span>
                  <span v-for="(item , index) in threesavedata[0].paramSafeDataList"  :class="'font' + item.checkSafe" >
                  <span v-if="index!=3">
                     {{item.paramValue=='-45.0'?'-':item.paramValue}}
                  </span>
                 <span v-else style="width: 100%;background-color: none;">
                          <span style="width: 60px;display: inline-block;background-color: none;">
                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}
                   </span>
                  <span style="font-size: 10px;">
                      ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})
                  </span>
                 </span>
                </span>

                </div>
                <div class="table-bom">
                  <span>B相</span>
                  <span v-for="(item , index) in threesavedata[1].paramSafeDataList" :class="'font' + item.checkSafe" >
                     <span v-if="index!=3">
                     {{item.paramValue=='-45.0'?'-':item.paramValue}}
                  </span>
                 <span v-else style="width: 100%;background-color: none;">
                          <span style="width: 60px;display: inline-block;background-color: none;">
                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}
                   </span>
                  <span style="font-size: 10px;">
                      ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})
                  </span>
                 </span>
                </span>
                </div>
                <div class="table-bom">
                  <span>C相</span>
                  <span v-for="(item , index) in threesavedata[2].paramSafeDataList" :class="'font' + item.checkSafe">
                     <span v-if="index!=3">
                     {{item.paramValue=='-45.0'?'-':item.paramValue}}
                  </span>
                 <span v-else style="width: 100%;background-color: none;">
                          <span style="width: 60px;display: inline-block;background-color: none;">
                    {{ item.paramValue=='-45.0'?'-':(item.paramValue * electricMul).toFixed(1)}}
                   </span>
                  <span style="font-size: 10px;">
                      ({{item.paramValue=='-45.0'?'-':Number(item.paramValue).toFixed(1)}})
                  </span>
                 </span>
                </span>
                </div>
              </div>

            </div>
            <div class="singletable" v-else-if="isthree=='3'">
              <div class="table-top" style="width: 186px;">


                <span style="width: 100%;">负荷电流（A）</span>

              </div>
              <div class="table-bom">

                <span>{{elesavedata.paramValue}}</span>

              </div>
            </div>
          </div>
          <div class="nodata-table" v-show="isthree==null">
            暂无数据
          </div>
          <div class="per-con" >
            电表倍率：{{nowbl}}
            <img @click="showbl()" style="width: 18px;margin-left: 10px;cursor:pointer;" src="../../assets/home/changedata.png" alt="">
          </div>
          <div class="power-data">
            监测点安全统计
          </div>
          <div class="item-group" style="margin-top: 24px;">
            <span class="item-btn " :class="isrisk=='yhtj'?'active-btn':''" @click="changerisk('yhtj')">
              隐患统计
              <div class="blue-blank">

              </div>
            </span>
            <span class="item-btn " :class="isrisk=='bjtj'?'active-btn':''" @click="changerisk('bjtj')">
              报警统计
              <div class="blue-blank">

              </div>
            </span>
            <span class="item-btn " :class="isrisk=='fxzb'?'active-btn':''" @click="changerisk('fxzb')">
              风险指标
              <div class="blue-blank">

              </div>
            </span>
            <div class="gray-line">

            </div>
          </div>
          <div class="risk-cav" v-show="isrisk=='yhtj'">
            <div class="cir-blank">
              <div class="cir-title">
                  <span class="blue-blank">

                  </span>
                <span class="new-risk">
                  隐患月新增：{{ thisMonthCount }}项
                </span>
                <span class="big-risk">
                  其中重大风险：{{ significantriskcount }}项，
                </span>
                <span >
                  较大风险：{{ greaterriskcount }}项
                </span>
              </div>
              <div class="cir-cav" id="riskCav">

              </div>
            </div>
            <div class="cir-table">
              <div class="gray-line">

              </div>
              <div class="detail-table">
                <div class="cir-title">
                  <span class="blue-blank">

                  </span>
                  <span class="new-risk">
                  未整改隐患：{{ unHandledCount }}项
                </span>
                  <span class="big-risk">
                  已整改隐患：{{ handledCount }}项
                </span>

                </div>
                <div class="table-blank">
                  <el-table
                    :data="risktable"
                    style="width: 100%"

                    class="tableList"
                  >

                    <el-table-column prop="riskName" label="隐患名称"   align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="发生时间"   align="center"> </el-table-column>
                    <el-table-column prop="expireDay" label="逾期时间(h)"   align="center" >
                    </el-table-column>
                    <el-table-column prop="time" label="操作"   align="center" >
                      <template slot-scope="scope">
                        <el-button  class="dobtn" type="primary" @click="openhisLayer(scope.row);isdeal=true">处置</el-button>

                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div class="warm-cav" v-show="isrisk=='bjtj'" >
            <savechart />
          </div>
          <div class="warm-cav" v-show="isrisk=='fxzb'" >
            <powelechart/>
          </div>
        </div>
      </div>

    </div>
    <div class="risk-history" v-show="showList">
      <img class="close-X" src="../../assets/station/close.png" alt="" @click="showList=false">
      <div class="his-con" v-show="ishis">
        <div class="risk-history-title">
          <el-tabs v-model="activeName" @tab-click="handlepageClick">
            <el-tab-pane label="历史隐患" name="历史隐患"></el-tab-pane>
            <el-tab-pane label="隐患统览" name="隐患统览"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="search-blank" >
          <div class="lsyh-con" v-show="activeName=='历史隐患'">
          <span class="time-select">
              <span>起止时间：</span>
            <el-date-picker
              v-model="hissttm"
              value-format="yyyy-MM-dd"
              style="width: 130px;"
              type="date"
              placeholder="开始时间"
            ></el-date-picker>
            -
            <el-date-picker
              style="width: 130px"
              v-model="hisedtm"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束时间"
            ></el-date-picker>
       <span style="margin-left: 20px;">整改状态：</span>
      <el-select v-model="statius"    style="width: 100px;margin-right: 12px;" placeholder="请选择">
        <el-option
          v-for="(item,index) in dosta"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
     <span class="search-btn" @click="getRiskList()">查询</span>
     <span class="restart-btn" @click="reset()">重置</span>
              </span>
            <div class="list-table">
              <el-table :data="hisList"  align="center">
                <el-table-column prop="riskLevelName" align="center"  label= "隐患等级"></el-table-column>
                <el-table-column prop="riskName"  align="center" label="隐患类型" ></el-table-column>
                <el-table-column prop="status" align="center"  label="整改状态" ></el-table-column>
                <el-table-column prop="updateTime" width="160" align="center"   label="上报时间"></el-table-column>
                <el-table-column align="center"  label="操作">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.status=='已处理'" class="dobtn" type="primary"  @click="openhisLayer(scope.row),isdeal=false">
                      查看</el-button>
                    <el-button v-else class="dobtn" type="primary"  @click="openhisLayer(scope.row);isdeal=true">处置</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="float: right;margin-right: 10px; margin-top: 10px;">
              <el-pagination
                @current-change="pageChange"
                background
                :current-page="nowpage"
                :page-size="riskpage"
                layout="total,prev, pager, next, jumper"
                :total="riskSum">
              </el-pagination>
            </div>
          </div>
          <div class="lsyh-con" v-show="activeName=='隐患统览'">

            <div class="list-table">
              <el-table :data="riskTypeList"  align="center">
                <el-table-column prop="riskLevelName" align="center"  label= "隐患等级"></el-table-column>
                <el-table-column prop="alertLevelName"  align="center" label="隐患类型" ></el-table-column>

                <el-table-column align="center"  label="操作">
                  <template slot-scope="scope">
                    <el-button  class="dobtn" type="primary"  @click="opendetail(scope.row)">
                      查看</el-button>

                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

        </div>
      </div>
      <div class="detail-con" v-show="!ishis">
        <div class="risk-history-title">
          <span style="float: left;margin: 20px 0 0 20px;z-index: 1000;width:26px;cursor:pointer;">
<img src="../../assets/home/returnbtn.png" alt="" @click="returnback()">
          </span>
          {{ alertLevelName }}
        </div>
        <span class="time-select">
              <span>起止时间：</span>
            <el-date-picker
              v-model="hissttm2"
              value-format="yyyy-MM-dd"
              style="width: 130px;"
              type="date"
              placeholder="开始时间"
            ></el-date-picker>
            -
            <el-date-picker
              style="width: 130px"
              v-model="hisedtm2"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束时间"
            ></el-date-picker>

     <span class="search-btn" @click="getRisktypeall()">查询</span>
     <span class="restart-btn" @click="reset2()">重置</span>
              </span>
        <div class="list-table">
          <el-table :data="detailList"  align="center">
            <el-table-column prop="causeVOS" align="center"  label= "预警值">
              <template slot-scope="scope">

                <p v-for="item in scope.row.causeVOS">
                  {{item.description}}:{{item.value}}
                </p>
              </template>
            </el-table-column>

            <el-table-column prop="createTime"  align="center"   label="上报时间"></el-table-column>

          </el-table>
        </div>
        <div style="float: right;margin-right: 10px; margin-top: 10px;">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="nowpage"
            :page-size="riskpage"
            layout="total,prev, pager, next, jumper"
            :total="riskSum">
          </el-pagination>
        </div>

      </div>

    </div>
    <el-dialog
      title="隐患处置"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      class="electricDialog03"
    >
      <div class="electricDialog__content" v-show="isdeal">
        <div class="content_top">
          <span> <img src="../../assets/station/icon.png" />隐患处理</span>
        </div>

        <el-input
          type="textarea"
          autosize
          placeholder="请输入内容"
          v-model="textarea1"
        >
        </el-input>
        <div class="confirm">
          <el-checkbox v-model="checked">确定已整改</el-checkbox>
          <el-button type="primary" class="btn" @click="uploadDeal()">提 交</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="footer__title">
          <img src="../../assets/station/historyIcon.png" />
          <p>处理历史</p>
        </div>
        <div class="step" style="">
          <el-steps direction="vertical" :active="1">
            <el-step title="步骤 1" v-for="item in dealList">
              <div
                slot="title"
                style="display: flex; justify-content: space-between"
              >
                <span class="fontStyle">    {{ item.updateTime }}</span
                ><span>  {{ item.status }}</span>
              </div>
              <div slot="description">
                <p class="fontStyle">
                     {{ item.measure }}
                </p>
                <div class="fontStyle" style="width: 100%; text-align: right">
                      {{ item.handlerName }}
                </div>
              </div>
            </el-step>


          </el-steps>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="电表倍率"
      :visible.sync="showbltc"
      :close-on-click-modal="false"
      append-to-body
      class="electricDialog03"
    >
      <div class="electricDialog__content" >
        <div class="content_top">
          <span> <img src="../../assets/station/icon.png" />修改倍率</span>
        </div>

        <el-input
          placeholder="请输入倍率"
          v-model="nowbl2"
        >
        </el-input>
        <div class="confirm">

          <el-button type="primary" class="btn" @click="uploadbl()">提 交</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Axios2 from "@/utils/Axios2";
import Vue from "vue";
import qs from "qs";
import savechart from "../stationManagePage/components/savechart";
import powerdata from "../stationManagePage/components/powerdata";
import powelechart from "../stationManagePage/components/powelechart";

export default {
  name: "stationDetailPage",
  data() {
    return {
      nowtab:"",
      showList:false,
      ishis:true,
      checked:false,
      activeName:"历史隐患",
      alertLevelName:"",
      textarea1:"",
      dialogVisible:false,
      isload:false,
      isb:false,
      dealList:[],
      riskTypeList:[],
      detailList:[],
      issave:"aqjc",
      isrisk:"yhtj",
      hissttm:"",
      hissttm2:"",
      warmedtm:"",
      warmsttm:"",
      edtm:"",
      saveid:"",
      hisedtm:"",
      hisedtm2:"",

      statius:"",
      tableData:[],
      dosta:[
        {
          label:"未处理",
          value:'1'
        },     {
          label:"全部",
          value:null
        },   {
          label:"已处理",
          value:"2"
        },  {
          label:"处理中",
          value:"3"
        },
      ],
      hisList:[],
      isdeal:"",
      nowpage:1,
      nowbl:1,
      riskAll:[],
      riskpage:10,
      riskSum:100,
      itemType:"",
      alertMessage:"",
      equmentdata:{
        siteName:"",
        manager:"",
        telephone:"",
        signalStrength:"",
      },
      lasttime:"",
      singlesavedata:[
        {paramSafeDataList:null},
        {paramSafeDataList:null},
        {paramSafeDataList:null},
        {paramSafeDataList:null},
        {paramSafeDataList:null},
        {paramSafeDataList:null},
        {paramSafeDataList:null},
      ],
      threesavedata:null,
      elesavedata:null,
      alertLevel:null,
      showrisk:false,
      showbltc:false,
      isthree:'2',
      setsavedata:null,
      greaterriskcount:"",
      thisMonthCount:"",
      handledCount:"",
      unHandledCount:"",
      risktable:[],
      significantriskcount:null,
      riskId:"",
      electricMul:1,
      nowbl2:1,
      elelast: {
        value:"",
        lev:"",
      },
      boxtem:{
        value:"",
        lev:"",
      },
      dqhzparm:{
        value:"",
        lev:"",
      },
      jylhparm:{
        value:"",
        lev:"",
      },
    };
  },
  methods: {
    uploadbl(){
      let that = this;
      let param = {};

      this.$confirm("建议专业电工人员确认后修改，倍率影响能耗统计，请确认修改", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        param.method="post";
        param.url="/monitorBoard/setElectricMul";
        param.data=
          {
            monitorSiteId:that.saveid,
            electricMul:that.nowbl2,
          }
        Axios.ajax(param).then((res)=>{
          if(res.resultCode=='0'){
            that.$message({
              type: 'success',
              message: '修改成功!'
            });
            that.showbltc=false
            that.getsavedata()
            that.getdbbl()
          }else{
            that.$message({
              type: 'error',
              message: res.msg
            });
          }
        })
      })

    },
    showbl(){
this.showbltc=true
    },
    getdbbl(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/getElectricMul";
      param.data=
        {
          monitorSiteId:this.saveid,
        }
      Axios.ajax(param).then((res)=>{


        this.nowbl=res.data
        this.nowbl2=res.data

      })
    },
    getRisktypeall(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/riskRecord/page";
      param.data=
        {

          "alertLevel":this.alertLevel,
          "endTime":  this.hisedtm2,
          "monitorId": this.saveid,
          "pageNum": this.nowpage,
          "showNum": this.riskpage,
          "startTime": this.hissttm2
        }
      Axios.ajax(param).then((res)=>{


        this.detailList=res.data.dataList
        this.riskSum=res.data.totalNum

      })
    },
    returnback(){
      this.ishis=!this.ishis
      this.riskpage='10'
      this.nowpage='1'
    },
    opendetail(data){

      this.alertLevel=data.alertLevel
      this.alertLevelName=data.alertLevelName

      this.ishis=!this.ishis
      this.riskpage='10'
      this.nowpage='1'
      this.getRisktypeall()
    },
    getriskTypeList(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/riskRecord/group";
      param.data=
        {
          monitorSiteId:this.saveid,
        }
      Axios.ajax(param).then((res)=>{


        this.riskTypeList=res.data

      })
    },
    handlepageClick(data){

      this.activeName=data.name
      this.riskpage='10'
      this.nowpage='1'
    },
    reset(){
      this.statius=""
      this.hisedtm=""
      this.hissttm=""
      this.riskpage='10'
      this.nowpage='1'
      this.getRiskList()
    },
    reset2(){

      this.hisedtm2=""
      this.hissttm2=""
      this.riskpage='10'
      this.nowpage='1'
      this.getRisktypeall()
    },
    showlist(){
      this.showList=true


      this.getRiskList()
      this.getriskTypeList()
    },
    uploadDeal(){
      this.dialogVisible = false
      let status=this.checked?'2':'3'
      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/risk/handle";
      param.data=
        {
          riskId:this.riskId,
          measure:this.textarea1,
          status:status,
        }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
          this.showdeal=false
          this.getRiskList()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      })
    },
    //获得实时数据
    getnow(){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/msg/query/realtime/";
      param.data=
        {
          address:this.equmentdata.addr485,
          topic:this.equmentdata.hostTerminalImei,
        }
      Axios2.ajax(param).then((res)=>{

        if(res.status=='200'){
          this.$message({
            type: 'success',
            message: '请求成功'
          });

        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

      })
    },
    getnewdata(){
      let that=this
      this.isload=true
      this.getnow()
      this.setsavedata=setInterval(function(){
        that.getsavedata()
        // that.getpowerdata()
      },3000)
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date

      var yesnow = new Date();
      yesnow.setTime(yesnow.getTime() - 24 * 60 * 60 * 1000);
      var yesyear = yesnow.getFullYear(); //得到年份
      var yesmonth = yesnow.getMonth(); //得到月份
      var yesdate = yesnow.getDate(); //得到日期

      var yeshour = yesnow.getHours(); //得到小时
      var yesminu = yesnow.getMinutes(); //得到分钟
      var yessec = yesnow.getSeconds(); //得到秒
      var yesMS = yesnow.getMilliseconds(); //获取毫秒
      yesmonth = yesmonth + 1;
      if (yesmonth < 10) yesmonth = "0" + yesmonth;
      if (yesdate < 10) yesdate = "0" + yesdate;
      if (yeshour < 10) yeshour = "0" + yeshour;
      if (yesminu < 10) yesminu = "0" + yesminu;
      if (yessec < 10) yessec = "0" + yessec;
      if (yesMS < 100) yesMS = "0" + yesMS;
      var yestime = "";
      yestime =
        yesyear +
        "-" +
        yesmonth +
        "-" +
        yesdate
      this.sttm = yestime;
      this.warmsttm = yestime;
      // this.hissttm = yestime;
      this.edtm = time;
      this.warmedtm = time;
      // this.hisedtm = time;
    },
    changeitem(data){
      this.itemType=data
      this.getcavdata(data)
    },
    //获得隐患数据
    getrisk(){

      let that = this;
      let param = {};
      param.method="get";
      param.url="/monitorBoard/riskAnalyze";
      param.params=
        {
          // monitorSiteId:31,
          monitorSiteId:this.saveid,
        }
      Axios.ajax(param).then((res)=>{
        if(res.data.length){
          this.showrisk=true
          this.riskAll=[]
          this.riskAll=res.data
          this.itemType=res.data[0].riskName
          this.alertMessage=res.data[0].alertMessage
          this.getcavdata(res.data[0].riskName)
        }else{
          this.showrisk=false
        }
      })
    },
    getcavdata(riskName){
      let that = this;
      let param = {};
      param.method="post";
      let keybord=''
      let type=''
      for(let i=0;i<this.riskAll.length;i++){
        if(this.riskAll[i].riskName==riskName){
          keybord=i
          this.alertMessage=this.riskAll[i].alertMessage
        }
      }
      param.data=qs.stringify({
        // "branchId":"52-1",
        "monitorSiteId":sessionStorage.getItem("saveid"),
        "params":this.riskAll[keybord].headers,
        "searchDate":this.edtm
      })
      if(this.riskAll[keybord].dataType=='1'){
        param.url="/analogData/hourFreezeDataInfoV2";
        type='bar'

      }else{
        param.url="/analogData/instantParamDataV2";
        type='line'
      }
      Axios.ajax(param).then((res)=>{

        let levlist=[]
        this.cavdata=[]
        if(res.data){
          if(res.data.checkSafeDatas){
            this.cavtitle=res.data.freezeDatas[0]
            for(let i=1;i<res.data.freezeDatas.length;i++){
              this.cavdata.push(res.data.freezeDatas[i])
              levlist.push(res.data.checkSafeDatas[i])
            }
            this.drewcav(this.cavtitle,this.cavdata,levlist,type)
          }else{
            this.cavtitle=res.data[0]
            for(let i=1;i<res.data.length;i++){
              this.cavdata.push(res.data[i])
            }
            this.drewcav(this.cavtitle,this.cavdata,'',type)
          }

        }

      })
      // else   if(this.riskAll[keybord].dataType=='2'){
      //   param.url="/analogData/instantParamDataV2";
      //   Axios.ajax(param).then((res)=>{
      //     let levlist=[]
      //     this.cavdata=[]
      //     if(res.resultCode=='0'){
      //       if(res.data.checkSafeDatas){
      //         this.cavtitle=res.data.freezeDatas[0]
      //         for(let i=1;i<res.data.freezeDatas.length;i++){
      //           this.cavdata.push(res.data.freezeDatas[i])
      //           levlist.push(res.data.checkSafeDatas[i])
      //         }
      //         this.drewcav(this.cavtitle,this.cavdata,levlist)
      //       }else{
      //         if(res.data[0].length==2){
      //           this.cavtitle=res.data[0]
      //           for(let i=1;i<res.data.length;i++){
      //             this.cavdata.push(res.data[i])
      //           }
      //           this.drewcav2(this.cavtitle,this.cavdata)
      //         }else{
      //           this.cavtitle=res.data[0]
      //           for(let i=1;i<res.data.length;i++){
      //             this.cavdata.push(res.data[i])
      //           }
      //           this.drewcav2(this.cavtitle,this.cavdata)
      //         }
      //
      //       }
      //
      //     }else{
      //
      //     }
      //
      //   })
      // }





    },

    drewcav(title,data,levlist,type){
      let xdata=[]
      let series=[]
      let legend=[]
      let colorlist=[['rgba(255, 255, 0,1)'],['rgba(20, 255, 20,1)'],['rgba(247, 20, 20,1)'],['#85f67a', ''],['#85f67a', ''],['#85f67a', ''],['rgba(255, 200, 0,1)'],['rgba(20, 200, 20,1)'],['rgba(200, 20, 20,1)']]
      for(let i=1;i<title.length;i++){
        series.push(
          {
            name: title[i],
            type: type,
            barWidth: '10px',
            itemStyle:{
              normal: {
                color:function(params){
                  let color=""
                  if(levlist){

                    if(title[i]=='电气火灾' || title[i]=='电气老化'){
                      if(levlist[(params.dataIndex)][1]=='1'){
                        color="rgba(20, 255, 20,1)"
                      }else if(levlist[(params.dataIndex)][1]=='2'){
                        color="rgba(255, 255, 0,1)"
                      }else if(levlist[(params.dataIndex)][1]=='3'){
                        color="rgba(255, 153, 0,1)"
                      }else if(levlist[(params.dataIndex)][1]=='4'){
                        color="rgba(247, 20, 20,1)"
                      }
                    }else  if(title[i].indexOf('A相') != -1){
                      color='rgb(0,128,0)'
                    }else if(title[i].indexOf('B相') != -1){
                      color='rgb(255,165,0)'
                    }else if(title[i].indexOf('C相') != -1){
                      color='rgb(255,0,0)'
                    }else{
                      color=colorlist[i-1][0]
                    }

                  }else{
                    color=colorlist[i-1][0]
                  }
                  return color

                },
                barBorderRadius: 11,
              }
            },
            lineStyle: {
              normal: {
                color:function(params){
                  let color=""
                  color=colorlist[i-1][0]
                  return color

                },

              }
            },
            data: []
          },
        )
        legend.push(title[i])
      }
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])

        for(let j=1;j<data[i].length;j++){

          series[j-1].data.push(data[i][j])
        }
      }

      let myChart =this.$echarts.init(document.getElementById('analyesCav'));
      myChart.clear()
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data:legend
        },

        grid: {
          right: '5%',
          bottom: '3%',
          left: '6%',
          top: '20px',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
              fontSize: 12,
            },
            //interval:0,
            //rotate:30
          },
        }],
        yAxis: [{
          type: 'value',
          nameTextStyle: {
            color: '#000'
          },
          position: 'left',
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show:false,
            lineStyle: {
              color: "#0B4CA9",
            }

          },
          axisLabel: {
            color: '#000',
            fontSize: 12,
          }
        }],
        series: series
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    drewcav2(title,data){
      console.log(title,data)
      let xdata=[]
      let ydata=[]

      let series=[]
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])
        ydata.push(data[i][1])

      }

      let colorlist=[['#248ff7','#6851f1'],['#febe13','#65e5dd'],['#f071ff', '#85f67a']]
      let myChart =this.$echarts.init(document.getElementById("analyesCav"));
      myChart.clear()
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        "dataZoom": [{
          "show": true,
          "height": 12,
          "xAxisIndex": [
            0
          ],
          bottom:'6%',
          "start": 10,
          "end": 90,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '110%',
          handleStyle:{
            color:"#d3dee5",

          },
          textStyle:{
            color:"#000"},
          borderColor:"#90979c"
        }, {
          "type": "inside",
          "show": true,
          "height": 20,
          "start": 1,
          "end": 35
        }],
        grid: {
          right: '10%',
          bottom: '13%',
          left: '6%',
          top: '20px',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
              fontSize: 12,
            },
            //interval:0,
            //rotate:30
          },
        }],
        yAxis: [{
          type: 'value',

          nameTextStyle: {
            color: '#000'
          },
          position: 'left',
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show:false,
            lineStyle: {
              color: "#0B4CA9",
            }

          },
          axisLabel: {
            color: '#000',
            fontSize: 12,
          }
        }],
        series:   {
          name: title[1],
          type: 'line',

          itemStyle: {
            normal: {
              color:"#19AF23",
              barBorderRadius: 11,
            }
          },
          data:ydata
        },
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    getequmentlist(){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitor/getMonitorSiteInfo";
      param.data=qs.stringify({
        monitorSiteId:this.saveid
      })
      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.equmentdata=res.data
          if(this.equmentdata.terminalTypeName=='YH-SMART1000S'){
            this.isthree='3'
          }else{
            if(this.equmentdata.terminalTypeName=='YH-SMART1000L'){
              this.isb=true
              console.log( this.isb)
            }
            if(res.data.terminalPhase=='3'){
              this.isthree='1'
            }else{
              this.isthree='2'
            }
          }
          this.getsavedata()
          // this.getrisk()
        }

      })
    },
    todatadetail(){
      Bus.$emit('pushrouter2', [this.equmentdata.siteName+'详情',this.equmentdata.branchId, this.saveid,"/dataDetail"])

    },
    changesave(data){
      this.issave=data
    },
    changerisk(data){
      this.isrisk=data
    },

    gettrendCav(){
      let myChart =this.$echarts.init(document.getElementById('trendCav'));
      let option = {
        color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'Email',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: 'Union Ads',
            type: 'line',
            stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: 'Video Ads',
            type: 'line',
            stack: 'Total',
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: 'Direct',
            type: 'line',
            stack: 'Total',
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: 'Search Engine',
            type: 'line',
            stack: 'Total',
            data: [820, 932, 901, 934, 1290, 1330, 1320]
          }
        ]
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    getriskCav(data){
      let arrdata=[]
      for(let i=0;i<data.length;i++){
        arrdata.push(  { value: data[i].count, name: data[i].alertLevelName })
      }
      let myChart =this.$echarts.init(document.getElementById('riskCav'));
      let option = {
        color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
        tooltip: {
          trigger: 'item'
        },

        series: [
          {
            name: '隐患类别',
            type: 'pie',
            radius: ['40%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,

            },

            labelLine: {
              show: false
            },
            data:arrdata
          }
        ]
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    getRiskList(){
      let that = this;
      let param = {};
      param.method="get";
      param.url="/monitorBoard/risk/history";
      param.params=
        {
          status:this.statius,
          showNum:this.riskpage,
          pageNum:this.nowpage,
          monitorSiteId:this.saveid,
          startTime:this.hissttm,
          endTime:this.hisedtm,
        }
      Axios.ajax(param).then((res)=>{
        this.riskSum=res.data.totalNum

        this.hisList=res.data.dataList

      })
    },
    openhisLayer(data){
      this.dialogVisible=true

      this.getriskdeal(data.riskId)
    },
    getriskdeal(riskId){
      let that = this;
      this.riskId=riskId
      let param = {};
      param.method="get";
      param.url="/monitorBoard/risk/handleHistory";
      param.params=
        {
          riskId:riskId,
        }
      Axios.ajax(param).then((res)=>{
        this.dealList=res.data
      })
    },
    // 当前页数
    pageChange(val) {
      this.nowpage = val
      this.getRiskList()
    },
    getsavedata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/monitorSafeData";
      param.data=qs.stringify({
        monitorSiteId:this.saveid,
      })
      Axios.ajax(param).then((res)=>{

        if(res.data){
          if( this.lasttime==""){
            this.lasttime=res.data.timestamp
          }else{
            if(this.lasttime!=res.data.timestamp){
              clearInterval(that.setsavedata);
              that.setsavedata = null;
              that.isload=false
            }
          }
          if(res.data.electricMul){
            this.electricMul=res.data.electricMul
          }

          if(res.data.safeData.length!=0){

            if( this.isthree=='1'){

              this.singlesavedata=res.data.safeData.slice(0,6)

              this.threesavedata=res.data.safeData.slice(1,4)
              for(let i=0;i<res.data.safeData.length;i++){
                if(res.data.safeData[i].safeDataType=="漏电"){
                  this.elelast.value=res.data.safeData[i].paramSafeDataList[0].paramValue
                  this.elelast.lev=res.data.safeData[i].paramSafeDataList[0].checkSafe
                }
                if(res.data.safeData[i].safeDataType=="箱温"){
                  this.boxtem.value=res.data.safeData[i].paramSafeDataList[0].paramValue
                  this.boxtem.lev=res.data.safeData[i].paramSafeDataList[0].checkSafe
                }
                if(res.data.safeData[i].safeDataType=="风险指数"){
                  this.dqhzparm.value=res.data.safeData[i].paramSafeDataList[0].paramValue
                  this.dqhzparm.lev=res.data.safeData[i].paramSafeDataList[0].checkSafe
                  if(res.data.safeData[i].paramSafeDataList.length>1){
                    this.jylhparm.value=res.data.safeData[i].paramSafeDataList[1].paramValue
                    this.jylhparm.lev=res.data.safeData[i].paramSafeDataList[1].checkSafe
                  }
                }
              }
            }else if(this.isthree=='3' ){


              this.elesavedata=res.data.safeData[0].paramSafeDataList[0]
            }
            else
            {

              for(let i=0;i<res.data.safeData.length;i++){
                if(res.data.safeData[i].safeDataType=="漏电"){
                  this.elelast.value=res.data.safeData[i].paramSafeDataList[0].paramValue
                  this.elelast.lev=res.data.safeData[i].paramSafeDataList[0].checkSafe
                }
                if(res.data.safeData[i].safeDataType=="箱温"){
                  this.boxtem.value=res.data.safeData[i].paramSafeDataList[0].paramValue
                  this.boxtem.lev=res.data.safeData[i].paramSafeDataList[0].checkSafe
                }
                if(res.data.safeData[i].safeDataType=="风险指数"){
                  this.dqhzparm.value=res.data.safeData[i].paramSafeDataList[0].paramValue
                  this.dqhzparm.lev=res.data.safeData[i].paramSafeDataList[0].checkSafe
                  if(res.data.safeData[i].paramSafeDataList.length>1){
                    this.jylhparm.value=res.data.safeData[i].paramSafeDataList[1].paramValue
                    this.jylhparm.lev=res.data.safeData[i].paramSafeDataList[1].checkSafe
                  }
                }
              }


              this.singlesavedata=res.data.safeData

            }
          }
          else{
            this.isthree=null
          }




        }

      })
    },
    getriskone(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/risk/monthCount";
      param.data={
        monitorSiteId:this.saveid,
      }
      Axios.ajax(param).then((res)=>{

        if(res.data){

        this.greaterriskcount=res.data.greaterRiskCount
        this.significantriskcount=res.data.significantRiskCount

        if(res.data.alertLevelRiskCounts){
          this.getriskCav(res.data.alertLevelRiskCounts)
        }
        }

      })
    },
    getrisktwo(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/risk/count";
      param.data={
        monitorSiteId:this.saveid,
      }
      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.thisMonthCount=res.data.thisMonthCount
          this.handledCount=res.data.handledCount
          this.unHandledCount=res.data.unHandledCount

        }

      })
    },
    getriskthree(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/risk/list";
      param.data={
        monitorSiteId:this.saveid,
      }
      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.risktable=res.data


        }

      })
    },
  },
  mounted() {
    let that=this
    this.saveid=sessionStorage.getItem('saveid');
    this.getnowtime()
    this.getequmentlist()
    this.getrisk()
    this.getdbbl()
    this.getsavedata()
    this.getriskone()
    this.getrisktwo()
    this.getriskthree()
    this.$once('hook:beforeDestroy',()=>{
      clearInterval(that.setsavedata);
      that.setsavedata = null;
    })
  },
  watch: {},
  components: {
    savechart,
    powerdata,
    powelechart
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.stationDetailPage{
  position: relative;
  .table-blank{
    height: 270px;
    overflow: auto;
  }
  .detail-top{
    height: 120px;
    background: #FFFFFF;
    border-radius: 4px;
    padding: 24px 0 0 36px;
    position: relative;
    .station-name{
      font-size: 16px;
      color: #2A62FF;
    }
    .station-message{
      margin-top: 24px;
      font-size: 14px;
      color: #7D879F;
    }
    .station-phone{
      margin:0 24px;
    }
    .statin-btn{
      position: absolute;
      right: 100px;
      bottom: 30px;
      .btn-item{
        display: inline-block;
        width: 80px;
        height: 40px;
        background: #2A62FF;
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        margin-left: 48px;
        cursor: pointer;
      }
    }
  }
  .risk-analyse{
    margin-top: 12px;
    height: 496px;
    background: #FFFFFF;
    border-radius: 4px;
  }

  .analyes-title{
    padding-left: 36px;
    height: 60px;
    line-height: 60px;
    color: #252B3C;
    font-size: 14px;
  }
  .gray-line{
    height: 2px;
    border: 1px solid #F1F0F0;
  }

  .analyes-cav{
    padding-left: 36px;
    padding-top: 28px;
  }
  .item-group{
    display:inline-block;
    cursor: pointer;
    .item-btn{
      font-size: 14px;
      color: #7D879F;
      margin-right: 36px;
      display: inline-block;
      z-index: 100;
      vertical-align: top;
      .blue-blank{
        width: 100%;
        margin-top: 12px;
        height: 2px;

      }

    }
    .item-btn:nth-last-child(2){
      margin-right: 10px;
    }
    .active-btn{
      color: #2A62FF;
      position: relative;
      .blue-blank{
        width: 100%;
        margin-top: 12px;
        height: 2px;
        background-color:  #2A62FF;

      }
    }
    .gray-line{
      height: 2px;
      border: 1px solid #F1F0F0;
      position: relative;
      top: -2px;
      z-index: 1;
    }
  }
  .title-detail{
    font-size: 12px;

    margin: 12px 0;
    color: Red;
  }

  .data-analyse{
    margin-top: 12px;
    height: 1000px;
    background: #FFFFFF;
    border-radius: 4px;
    margin-bottom: 20px;
  }
  .power-data{
    margin-top: 40px;
    color: #252B3C;
    font-size: 14px;

  }
  .data-card{
    margin-top: 24px;
    position: relative;
    .btn-item{
      position: absolute;
      right: 40px;
      top: 20px;
      display: inline-block;
      width: 120px;
      height: 40px;
      background: #2A62FF;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      margin-left: 48px;
      cursor: pointer;

    }
  }
  .card-item{
    width: 400px;
    display: inline-block;
    vertical-align: top;
    height: 122px;
    background: #F5F8FD;
    color: #7D879F;
    font-size: 14px;
    margin-right: 20px;
    .card-left{
      width: 50%;
      display: inline-block;
      vertical-align: top;
      padding: 33px 0 0 30px;
      .blue-font{
        margin-top: 14px;
        color: #2A62FF;
        font-size: 20px;
      }
      .red-font{

        font-size: 12px;
        color: #D61E1E;
        margin-left: 8px;
      }
      .green-font{

        font-size: 12px;
        color: #008B61;
        margin-left: 8px;
      }
      .gray-font{
        margin-top: 14px;
        font-size: 20px;
      }
    }
  }
  .warm-blank{
    width: 1400px;
    margin: 0 auto;
    height: 300px;
  }
  .title-risk{
    padding-top: 10px;
    .risk-list{
      display: inline-block;
      margin-left: 40px;
      vertical-align: center;
      .big-num{

        font-size: 24px;
        margin-left: 20px;
      }
      .green-color{
        color: #19AF23;
      }
    }
  }
  .risk-history{
    width: 759px;
    height: 750px;
    background: #FFFFFF;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    position: absolute;
    top: 100px;
    right: 21px;
    .risk-history-title{
      padding-left: 10px;
      text-align: center;
      color: #252B3C;
      font-size: 16px;
      height: 64px;
      line-height: 64px;
    }
    .close-X{
      position: absolute;
      top: 23px;
      right: 23px;
      cursor: pointer;
      z-index: 1000;
    }
    .search-blank{
      padding:11px 36px 0 36px;
    }
    .search-btn{
      width: 56px;
      height: 28px;
      background: #2A62FF;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      line-height: 28px;
      display:inline-block;
      margin: 0 12px;
      cursor: pointer;
    }
    .restart-btn{
      width: 56px;
      height: 28px;
      background: #fff;
      border-radius: 4px;
      color: #2A62FF;
      text-align: center;
      line-height: 28px;
      display:inline-block;
      border: 1px solid #2A62FF;
      cursor: pointer;
    }
  }
  .list-table{
    margin-top: 14px;
    height: 580px;
    overflow: auto;
  }
  .alltable{
    margin-left: 20px;
    margin-top: 20px;
    margin-right: 20px;
    height: 300px;

    .table-top{


      span{
        background-color: rgba(0,0,0,0.02);
        border-bottom: 1px dashed #ddd;
        display: inline-block;
        vertical-align: top;
        width:13%;
        height: 60px;
        line-height: 60px;
        text-align: center;

      }
      span:first-child{
        width: 6%;
      }
    }
    .table-bom{
       > span{
        display: inline-block;
        vertical-align: top;
        width:13%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-bottom: 1px dashed #ddd;
        background-color: rgba(0,0,0,0.02);
      }
      > span:first-child{
        width: 6%;
        background-color: rgba(0,0,0,0.02);
      }
    }
  }
  .singletable{
    margin-left: 0px;
    margin-top: 40px;
    margin-right: 0px;
    height: 300px;
    width: 100%;
    .table-top{

      span{
        background-color: rgba(0,0,0,0.02);
        border-bottom: 1px dashed #ddd;
        display: inline-block;
        vertical-align: top;
        width:8%;
        height: 60px;
        line-height: 60px;
        text-align: center;
      }
      span:first-child{
        width: 9%;
      }
      span:nth-child(n+2):nth-child(-n+3) {
        width: 11%;
      }
      span:nth-child(4) {
        width: 6%;
      }
      span:nth-child(8) {
        width: 6%;
      }
    }
    .table-bom{
      > span{
        display: inline-block;
        vertical-align: top;
        width:8%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-bottom: 1px dashed #ddd;
        background-color: rgba(0,0,0,0.02);
      }
      span:first-child{
        width: 9%;
        background-color: rgba(0,0,0,0.02);
      }
      span:nth-child(n+2):nth-child(-n+3) {
        width: 11%;
        background-color: rgba(0,0,0,0.02);
      }
      span:nth-child(4) {
        width: 6%;
        background-color: rgba(0,0,0,0.02);
      }
      span:nth-child(8) {
        width: 6%;
        background-color: rgba(0,0,0,0.02);
      }
    }
  }
  .save-item{
    position: relative;
    display: inline-block;
    height: 50px;
    padding-left: 16px;
    margin-right: 150px;
    .blue-blank{
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 50px;
      background: #2A62FF;
    }
    .green-font{

      font-size: 14px;
      color: #008B61;

    }
    .red-font{
      font-size: 14px;
      color: #D61E1E;
    }
    .org-font{
      font-size: 14px;
      color: #D17300;
    }
    .yel-font{
      font-size: 14px;
      color: #D1B500;
    }
    .blue-font{
      font-size: 14px;
      color: #2A62FF;
    }

    .item-tips{
      margin-top: 14px;
      color: #7D879F;
    }
  }
  .data-table{
    padding: 0 36px 0 0;
    margin-top: 18px;
    height: 240px;
  }
  .nodata-table{
    padding: 0 36px 0 0;
    margin-top: 18px;
    height: 240px;
    text-align: center;
    line-height: 240px;
    font-size: 20px;
  }
  .font1{

    font-size: 14px;
    color: #008B61;

  }
  .font4{
    font-size: 14px;
    color: #D61E1E;
  }
  .font3{
    font-size: 14px;
    color: #D17300;
  }
  .font2{
    font-size: 14px;
    color: #D1B500;
  }
  .risk-cav{

    .cir-blank{
      display: inline-block;
      vertical-align: top;
      width: 426px;
      height: 417px;
    }
    .cir-title{
      margin: 24px 0;

      color: #252B3C;
      font-size: 14px;
      .blue-blank{
        display: inline-block;
        vertical-align: top;
        width: 2px;
        height: 17px;
        background: #2A62FF;
      }
      .new-risk{
        margin: 0 36px 0 14px;
      }
      .big-risk{
        margin: 0 36px 0 0px;
      }
    }
    .cir-table{
      display: inline-block;
      vertical-align: top;
      width: calc(100% - 426px);
      padding-left: 137px;
      .gray-line{
        width: 1px;
        height: 274px;
        border: 1px solid #E4E7ED;
        display: inline-block;
        vertical-align: top;
        margin-top: 12px;
        margin-right: 176px;
      }
      .detail-table{
        width: calc(100% - 200px);
        display: inline-block;
        vertical-align: top;
      }
    }
    .cir-cav{
      width: 425px;
      height: 260px;
    }
  }
}
.cav-chart{
  width: 1600px;
  margin: 0 auto;
  height: 260px;
}
.per-con{
  padding: 20px 0 0 40px;
}
</style>
<style lang="less">
#app .el-pagination .el-pager li.active{
  color: #fff;
}
#app .stationDetailPage .risk-history .el-table td, .el-table th.is-leaf{
  border-bottom: 1px dashed rgba(0,0,0,0.2);
}
#app .stationDetailPage  .el-table td, .el-table th.is-leaf{

}
#app .stationDetailPage .el-table th, .el-table tr{
  height: 53px;
  background-color: #fff;
}
#app .stationDetailPage .el-table thead{
color: #7D879F;
}
.electricDialog03 {
.el-dialog {
  padding: 0 45px;
  width: 759px;
  border-radius: 8px;
.el-dialog__header {
  text-align: center;
  font-size: 16px;
  color: red;
  font-weight: normal;
.el-dialog__headerbtn {
  right: 65px;
  font-size: 24px;
}
}
.el-dialog__body {
  border-bottom: 1px solid #f1f0f0;
.electricDialog__content {
.content_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
span {
  font-size: 16px;
  font-weight: normal;
  color: #252b3c;
img {
  margin-right: 12px;
}
}
.el-checkbox {
  font-size: 14px;
}
}
.el-textarea {
.el-textarea__inner {
  min-height: 80px !important;
  height: 80px !important;
}
}
.confirm {
  padding-top: 20px;
  text-align: right;
.el-button {
  margin-left: 32px;
  background-color: #2a62ff;
  border-color: #2a62ff;
}
}
}
}

.el-dialog__footer {
.footer__title {
  margin: 24px 0;
  display: flex;
p {
  margin-left: 12px;
  font-size: 16px;
  color: #252b3c;
}
}
.step {
  max-height: 300px;
  overflow-y: scroll;
.el-step__description {
  padding: 0;
}
.fontStyle {
  font-size: 14px;
  color: #252b3c;
}
}
.step::-webkit-scrollbar {
  width: 0 !important;
}
}
}
}
</style>
